// @flow
import './index.less';

import React from 'react';

const RTMCampaignDetails = (): React$Node => (
  <div className="rtm-details">
    <span>exclusive</span>
    <h1>Congratulations, you're an instant winner!</h1>
    <p>
      Create your account below to complete the redemption of your 1-Month Subscription to Ritual FIT (Valued at $19.99)
    </p>
  </div>
);

export default RTMCampaignDetails;
